import React, { useEffect, useRef } from 'react';
import { useAuth, useUser } from '@clerk/clerk-react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchClientByEmail,
  clearSelectedClient,
  selectedClientSelector
} from '../store/slices/selectedClient';

const AuthWrapper = ({ children }) => {
  const isDevBypass =
    process.env.REACT_APP_DEV_BYPASS === 'true' ||
    (typeof window !== 'undefined' &&
      localStorage.getItem('devBypass') === 'true');

  const { isSignedIn, isLoaded } = useAuth();
  const { user } = useUser();
  const dispatch = useDispatch();
  const { selectedClient, loading } = useSelector(selectedClientSelector);
  const hasFetchedClient = useRef(false);
  const lastUserEmail = useRef(null);

  // Resetear cuando cambia el usuario o se deslogea
  useEffect(() => {
    if (isDevBypass) return;

    const currentEmail = user?.primaryEmailAddress?.emailAddress;

    if (!isSignedIn) {
      hasFetchedClient.current = false;
      lastUserEmail.current = null;
    } else if (currentEmail && lastUserEmail.current !== currentEmail) {
      hasFetchedClient.current = false;
      lastUserEmail.current = currentEmail;
    }
  }, [isDevBypass, isSignedIn, user?.primaryEmailAddress?.emailAddress]);

  useEffect(() => {
    const fetchClientData = async () => {
      if (isDevBypass) return;

      if (
        !isLoaded ||
        !isSignedIn ||
        !user?.primaryEmailAddress?.emailAddress
      ) {
        return;
      }

      // Si ya hay un cliente cargado y no está cargando, no hacer nada
      if (selectedClient && !loading) {
        return;
      }

      // Evitar llamadas múltiples
      if (hasFetchedClient.current) {
        return;
      }

      // Si está cargando, esperar
      if (loading) {
        return;
      }

      hasFetchedClient.current = true;
      dispatch(clearSelectedClient());

      try {
        const userEmail = user.primaryEmailAddress.emailAddress;
        const result = await dispatch(fetchClientByEmail(userEmail));

        if (!fetchClientByEmail.fulfilled.match(result)) {
          console.error('Error al cargar cliente:', result.payload);
          hasFetchedClient.current = false;
        }
      } catch (error) {
        console.error('Error al obtener datos del cliente:', error);
        hasFetchedClient.current = false;
      }
    };

    fetchClientData();
  }, [
    isSignedIn,
    isLoaded,
    user,
    dispatch,
    selectedClient,
    loading,
    isDevBypass
  ]);

  return <>{children}</>;
};

export default AuthWrapper;
